<template>
  <el-dialog
    title="银行流水"
    :visible.sync="dialogVisible"
    width="90%"
    @close="handleClose"
  >
    <div class="bank-income-container">
      <!-- 搜索条件 -->
      <div class="search-bar">
        <el-form :inline="true" size="mini">
          <el-form-item label="银行">
            <el-input v-model="searchForm.bank" placeholder="请输入银行名称" clearable style="width: 150px"></el-input>
          </el-form-item>
          <el-form-item label="客户名称">
            <el-input v-model="searchForm.customer" placeholder="请输入客户名称" clearable style="width: 150px"></el-input>
          </el-form-item>
          <el-form-item label="报盘时间">
            <el-date-picker
              v-model="payTimeRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              style="width: 240px"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search">查询</el-button>
            <el-button @click="resetSearch">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="showImportDialog('deduction')">导入划扣</el-button>
            <el-button type="warning" @click="showImportDialog('collection')">导入集中代收</el-button>
            <el-button type="default" @click="showCbsIncome">CBS流水</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="showMatchDialog">匹对收款</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 银行流水表格 -->
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%; margin-top: 10px"
        max-height="500"
        @selection-change="handleBankIncomeSelectionChange"
      >
        <el-table-column type="selection" width="50" align="center"></el-table-column>
        <el-table-column prop="bank" label="银行" width="120" align="center"></el-table-column>
        <el-table-column prop="bank_name" label="开户行" width="180" align="center"></el-table-column>
        <el-table-column prop="bank_card" label="银行卡号" width="180" align="center"></el-table-column>
        <el-table-column prop="customer" label="客户名称" width="150" align="center"></el-table-column>
        <el-table-column prop="pay_no" label="银行流水号"></el-table-column>
        <el-table-column prop="amount" label="金额" width="120" align="center">
          <template slot-scope="scope">
            <span>{{ formatMoney(scope.row.amount) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="use_amount" label="已勾兑金额" width="120" align="center">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.use_amount > 0 ? '#67C23A' : '#909399' }">
              {{ formatMoney(scope.row.use_amount) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="unverified_amount" label="未勾兑金额" width="120" align="center">
          <template slot-scope="scope">
            <span :style="{ color: getUnverifiedAmount(scope.row) > 0 ? '#F56C6C' : '#909399' }">
              {{ formatMoney(getUnverifiedAmount(scope.row)) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="pay_time" label="报盘时间" width="160" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="150" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="100" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" v-if="scope.row.use_amount == 0" @click="deleteItem(scope.row)">删除</el-button>
            <el-button size="mini" type="text" @click="viewDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 15px; text-align: right"
        background
        layout="total, prev, pager, next, jumper"
        :total="totalCount"
        :page-size="pageSize"
        :current-page="currentPage"
        @current-change="handlePageChange"
      ></el-pagination>
    </div>

    <!-- 导入对话框 -->
    <el-dialog
      :title="importDialogTitle"
      :visible.sync="importDialogVisible"
      width="500px"
      append-to-body
    >
      <el-upload
        ref="upload"
        class="upload-demo"
        drag
        :action="uploadUrl"
        :on-success="handleUploadSuccess"
        :on-error="handleUploadError"
        :before-upload="beforeUpload"
        :file-list="fileList"
        :auto-upload="true"
        accept=".xlsx,.xls"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传 xlsx/xls 文件，且不超过10MB</div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="downloadTemplate(importType)">下载模板</el-button>
      </div>
    </el-dialog>

    <!-- 详情对话框 -->
    <el-dialog
      title="银行流水详情"
      :visible.sync="detailDialogVisible"
      width="600px"
      append-to-body
    >
      <el-descriptions :column="2" border v-if="detailData">
        <el-descriptions-item label="银行">{{ detailData.bank }}</el-descriptions-item>
        <el-descriptions-item label="开户行">{{ detailData.bank_name }}</el-descriptions-item>
        <el-descriptions-item label="银行卡号">{{ detailData.back_card }}</el-descriptions-item>
        <el-descriptions-item label="客户名称">{{ detailData.customer }}</el-descriptions-item>
        <el-descriptions-item label="回款金额">{{ formatMoney(detailData.amount) }}</el-descriptions-item>
        <el-descriptions-item label="已勾兑金额">{{ formatMoney(detailData.use_amount) }}</el-descriptions-item>
        <el-descriptions-item label="未勾兑金额">{{ formatMoney(getUnverifiedAmount(detailData)) }}</el-descriptions-item>
        <el-descriptions-item label="报盘时间">{{ detailData.pay_time }}</el-descriptions-item>
        <el-descriptions-item label="付款号">{{ detailData.pay_no }}</el-descriptions-item>
        <el-descriptions-item label="开户行所在地">{{ detailData.bank_address }}</el-descriptions-item>
        <el-descriptions-item label="账号类型">{{ detailData.bank_type }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ detailData.remark }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>

      <!-- 匹对收款对话框 -->
    <el-dialog
      title="匹对收款"
      :visible.sync="matchDialogVisible"
      width="90%"
      append-to-body
    >
      <div class="match-container">
        <!-- 回款性质选择 -->
        <div class="match-section" style="margin-bottom: 15px; padding: 15px; background-color: #fff;">
          <el-form :inline="true" size="small">
            <el-form-item label="回款性质" required>
              <el-select v-model="matchForm.incomeType" placeholder="请选择回款性质" style="width: 200px">
                <el-option
                  v-for="item in incomeTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>

        <!-- 左侧：已勾选账单 -->
        <div class="match-section">
          <div class="section-title">已勾选账单（{{ matchForm.invoices.length }}条）</div>
          <el-table
            :data="matchForm.invoices"
            border
            max-height="400"
            style="width: 100%"
          >
            <el-table-column prop="party_a" label="客户名称" width="150" align="center"></el-table-column>
            <el-table-column prop="project_name" label="项目名称" width="150" align="center"></el-table-column>
            <el-table-column prop="month" label="应收月份" width="100" align="center"></el-table-column>
            <el-table-column prop="invoice_amount" label="开票金额" width="120" align="center">
              <template slot-scope="scope">
                {{ formatMoney(scope.row.invoice_amount) }}
              </template>
            </el-table-column>
            <el-table-column prop="invoice_ticket_no" label="发票号" width="150" align="center"></el-table-column>
            <el-table-column prop="owe_amount" label="欠款金额" width="120" align="center">
              <template slot-scope="scope">
                <span style="color: #F56C6C">{{ formatMoney(scope.row.owe_amount) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="收款金额" width="150" align="center">
              <template slot-scope="scope">
                <el-input-number
                  v-model="matchForm.invoiceAmounts[getInvoiceKey(scope.row)]"
                  :min="0"
                  :max="parseFloat(scope.row.owe_amount) || 0"
                  :precision="2"
                  :step="0.01"
                  size="mini"
                  controls-position="right"
                  @change="validateAmount(getInvoiceKey(scope.row), matchForm.invoiceAmounts[getInvoiceKey(scope.row)])"
                  style="width: 100%"
                ></el-input-number>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 右侧：已选择银行流水 -->
        <div class="match-section">
          <div class="section-title">已选择银行流水（只能选择1条）</div>
          <el-table
            :data="selectedBankIncomes"
            border
            style="width: 100%"
          >
            <el-table-column prop="bank" label="银行" width="120" align="center"></el-table-column>
            <el-table-column prop="bank_name" label="开户行" width="180" align="center"></el-table-column>
            <el-table-column prop="back_card" label="银行卡号" width="180" align="center"></el-table-column>
            <el-table-column prop="customer" label="客户名称" width="150" align="center"></el-table-column>
            <el-table-column prop="amount" label="回款金额" width="120" align="center">
              <template slot-scope="scope">
                {{ formatMoney(scope.row.amount) }}
              </template>
            </el-table-column>
            <el-table-column prop="use_amount" label="已勾兑金额" width="120" align="center">
              <template slot-scope="scope">
                {{ formatMoney(scope.row.use_amount) }}
              </template>
            </el-table-column>
            <el-table-column label="未勾兑金额" width="120" align="center">
              <template slot-scope="scope">
                <span style="color: #F56C6C; font-weight: bold">
                  {{ formatMoney(getUnverifiedAmount(scope.row)) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="pay_time" label="报盘时间" width="160" align="center"></el-table-column>
          </el-table>
        </div>

      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="matchDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmMatch">确认匹对</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import CommonHelp from "./common/CommonHelp";
import {Message} from "element-ui";
import Api from "./common/Api";

export default {
  name: 'BankIncome',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 已勾选的账单数据（从父组件传入）
    selectedInvoices: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      tableData: [],
      totalCount: 0,
      currentPage: 1,
      pageSize: 15,

      searchForm: {
        bank: '',
        customer: '',
        startDate: '',
        endDate: ''
      },
      payTimeRange: [],

      importDialogVisible: false,
      importDialogTitle: '',
      importType: '', // deduction: 划扣, collection: 集中代收
      fileList: [],
      uploadUrl: '',

      detailDialogVisible: false,
      detailData: null,

      // 匹对对话框
      matchDialogVisible: false,
      matchForm: {
        invoices: [], // 已勾选的账单
        bankIncome: null, // 已选择的银行流水
        invoiceAmounts: {}, // 每条账单的收款金额 {financeId: amount}
        incomeType: '' // 回款性质
      },
      selectedBankIncomes: [], // 表格中选中的银行流水
      incomeTypeOptions: [
        { label: '当期', value: '当期' },
        { label: '历史', value: '历史' }
      ]
    };
  },
  computed: {
    // 计算账单总收款金额
    totalInvoiceAmount() {
      let total = 0;
      for (const financeId in this.matchForm.invoiceAmounts) {
        total += parseFloat(this.matchForm.invoiceAmounts[financeId]) || 0;
      }
      return total;
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.loadData();
      }
    },
    dialogVisible(val) {
      this.$emit('update:visible', val);
      if (!val) {
        this.resetSearch();
      }
    }
  },
  methods: {
    // 加载数据
    loadData() {
      this.loading = true;
      const params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        ...this.searchForm
      };

      this.$myhttp
        .post('contract/BankIncome/index', params, {
          'Content-Type': 'application/json'
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.tableData = res.data.data || [];
            this.totalCount = res.data.totalCount || 0;
            this.currentPage = res.data.page || 1;
          } else {
            this.$message.error(res.data.msg || '加载失败');
          }
        })
        .catch((err) => {
          this.$message.error('网络错误：' + err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 搜索
    search() {
      this.currentPage = 1;
      if (this.payTimeRange && this.payTimeRange.length === 2) {
        this.searchForm.startDate = this.payTimeRange[0];
        this.searchForm.endDate = this.payTimeRange[1];
      } else {
        this.searchForm.startDate = '';
        this.searchForm.endDate = '';
      }
      this.loadData();
    },

    // 重置搜索
    resetSearch() {
      this.searchForm = {
        bank: '',
        customer: '',
        startDate: '',
        endDate: ''
      };
      this.payTimeRange = [];
      this.currentPage = 1;
      this.loadData();
    },

    // 分页改变
    handlePageChange(page) {
      this.currentPage = page;
      this.loadData();
    },

    // 查看详情
    viewDetail(row) {
      this.detailData = row;
      this.detailDialogVisible = true;
    },

    // 显示导入对话框
    showImportDialog(type) {
      this.importType = type;
      this.importDialogTitle = type === 'deduction' ? '导入划扣流水' : '导入集中代收流水';
      this.fileList = [];
      this.uploadUrl = this.getUploadUrl(type);
      this.importDialogVisible = true;
    },

    // 获取上传URL
    getUploadUrl(type) {
      return type === 'deduction'
        ? Api.getUploadUrl('/contract/BankIncome/importDeduction')
        : Api.getUploadUrl('/contract/BankIncome/importCollection');
    },

    // 下载模板
    downloadTemplate(type) {
      const templateName = type === 'deduction' ? '划扣模板' : '集中代收模板';

      this.$myhttp
        .get('contract/BankIncome/downloadTemplate?type=' + type, {
          'Content-Type': 'application/json'
        }).then((res) => {
          if (res.data.code === 200) {
            // 获取文件路径并转换为可访问的URL
            const fileUrl = CommonHelp.getBaseURL() + res.data.data.file_path;

            // 创建隐藏的a标签进行下载
            const link = document.createElement('a');
            link.href = fileUrl;
            link.download = res.data.data.file_name;
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            Message.success(templateName + '下载成功');
          } else {
            Message.error(res.data.msg || '模板生成失败');
          }
        })
        .catch((err) => {
          Message.error('网络错误：' + err);
        });
    },

    // 上传前验证
    beforeUpload(file) {
      const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                      file.type === 'application/vnd.ms-excel';
      if (!isExcel) {
        this.$message.error('只能上传 Excel 文件！');
        return false;
      }
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB！');
        return false;
      }
      return true;
    },

    // 上传成功
    handleUploadSuccess(response, file, fileList) {
      if (response.code === 200) {
        this.$message.success(response.msg);
        this.importDialogVisible = false;
        this.fileList = [];

        // 如果有失败记录，显示详细信息
        if (response.data && response.data.fail_count > 0) {
          this.$alert(
            '成功导入 ' + response.data.success_count + ' 条数据，失败 ' + response.data.fail_count + ' 条。<br/><br/>' +
            (response.data.errors ? response.data.errors.join('<br/>') : ''),
            '导入结果',
            {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '确定'
            }
          );
        }

        // 重新加载数据
        this.loadData();
      } else {
        this.$message.error(response.msg || '导入失败');
      }
    },

    // 上传失败
    handleUploadError(err, file, fileList) {
      this.$message.error('上传失败：' + err);
    },

    // 格式化金额
    formatMoney(amount) {
      if (amount === null || amount === undefined || amount === '') {
        return '0.00';
      }
      return parseFloat(amount).toFixed(2);
    },

    // 计算未勾兑金额
    getUnverifiedAmount(row) {
      const amount = parseFloat(row.amount) || 0;
      const useAmount = parseFloat(row.use_amount) || 0;
      return amount - useAmount;
    },

    // 关闭对话框
    handleClose() {
      this.$emit('close');
    },

    // 删除银行流水
    deleteItem(row) {
      this.$confirm('确认删除该条银行流水吗？删除后不可恢复！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$myhttp
          .post('contract/BankIncome/delete', { id: row.id })
          .then((res) => {
            if (res.data.code === 200) {
              Message.success('删除成功');
              // 重新加载数据
              this.loadData();
            } else {
              Message.error(res.data.msg || '删除失败');
            }
          })
          .catch((err) => {
            Message.error('网络错误：' + err);
          });
      }).catch(() => {
        Message.info('已取消删除');
      });
    },

    // 显示匹对对话框
    showMatchDialog() {
      // 检查是否有勾选的账单
      if (!this.selectedInvoices || this.selectedInvoices.length === 0) {
        this.$message.warning('请先在账单列表中选择要收款的账单');
        return;
      }

      // 初始化匹对表单
      this.matchForm.invoices = JSON.parse(JSON.stringify(this.selectedInvoices));
      this.matchForm.bankIncome = null;
      this.matchForm.invoiceAmounts = {};
      this.matchForm.incomeType = ''; // 重置回款性质

      // 为每条账单初始化收款金额为0
      this.matchForm.invoices.forEach(invoice => {
        const key = invoice.finance_id || invoice.id;
        this.matchForm.invoiceAmounts[key] = 0;
      });

      this.matchDialogVisible = true;
    },

    // 处理银行流水选择变化（单选）
    handleBankIncomeSelectionChange(selection) {
      // 如果选择了多条，只保留最后一条
      if (selection.length > 1) {
        // 获取最新选中的行（最后一条）
        const newRow = selection[selection.length - 1];

        // 清空所有选中
        this.$refs.bankIncomeTable.clearSelection();

        // 只选中最新的一行
        this.$nextTick(() => {
          this.$refs.bankIncomeTable.toggleRowSelection(newRow, true);
        });

        this.selectedBankIncomes = [newRow];
      } else {
        this.selectedBankIncomes = selection;
      }
    },

    // 确认匹对
    confirmMatch() {
      // 0. 验证回款性质
      if (!this.matchForm.incomeType) {
        this.$message.warning('请选择回款性质');
        return;
      }

      // 1. 验证是否选择了银行流水
      if (this.selectedBankIncomes.length === 0) {
        this.$message.warning('请选择一条银行流水');
        return;
      }

      if (this.selectedBankIncomes.length > 1) {
        this.$message.warning('只能选择一条银行流水');
        return;
      }

      const bankIncome = this.selectedBankIncomes[0];
      const unverifiedAmount = parseFloat(bankIncome.amount) - parseFloat(bankIncome.use_amount);

      // 2. 计算总收款金额
      let totalAmount = 0;
      for (const financeId in this.matchForm.invoiceAmounts) {
        const amount = parseFloat(this.matchForm.invoiceAmounts[financeId]) || 0;
        totalAmount += amount;
      }

      // 3. 验证总收款金额不能大于未勾兑金额
      if (totalAmount <= 0) {
        this.$message.warning('请至少填写一条账单的收款金额');
        return;
      }

      if (totalAmount > unverifiedAmount) {
        this.$message.error(
          `总收款金额(${totalAmount.toFixed(2)})不能超过银行流水未勾兑金额(${unverifiedAmount.toFixed(2)})`
        );
        return;
      }

      // 4. 验证每条账单的收款金额不能大于欠款金额
      for (const invoice of this.matchForm.invoices) {
        const key = invoice.finance_id || invoice.id;
        const amount = parseFloat(this.matchForm.invoiceAmounts[key]) || 0;
        const oweAmount = parseFloat(invoice.owe_amount) || 0;
        if (amount > oweAmount) {
          this.$message.error(
            `${invoice.party_a} - ${invoice.month} 的收款金额不能超过欠款金额(${oweAmount.toFixed(2)})`
          );
          return;
        }
      }

      // 5. 构建提交数据
      const submitData = {
        bank_income_id: bankIncome.id,
        income_type: this.matchForm.incomeType, // 回款性质
        invoices: this.matchForm.invoices.map(invoice => {
          const key = invoice.finance_id || invoice.id;
          return {
            finance_id: key,
            invoice_id: invoice.invoice_id || invoice.id,
            contract_id: invoice.contract_id,
            party_a: invoice.party_a,
            project_name: invoice.project_name,
            month: invoice.month,
            amount: parseFloat(this.matchForm.invoiceAmounts[key]) || 0,
            owe_amount: invoice.owe_amount
          };
        })
      };

      // 6. 提交匹对请求
      this.$confirm(`确认将 ${totalAmount.toFixed(2)} 元进行匹对收款吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$myhttp
          .post('contract/BankIncome/matchPayment', submitData)
          .then((res) => {
            if (res.data.code === 200) {
              this.$message.success('匹对收款成功');
              this.matchDialogVisible = false;
              this.selectedBankIncomes = [];
              // 通知父组件刷新数据
              this.$emit('match-success');
              // 重新加载银行流水数据
              this.loadData();
            } else {
              this.$message.error(res.data.msg || '匹对收款失败');
            }
          })
          .catch((err) => {
            this.$message.error('网络错误：' + err);
          });
      }).catch(() => {
        this.$message.info('已取消匹对');
      });
    },

    // 限制收款金额输入
    validateAmount(financeId, value) {
      const invoice = this.matchForm.invoices.find(inv => (inv.finance_id || inv.id) === financeId);
      if (!invoice) return;

      const oweAmount = parseFloat(invoice.owe_amount) || 0;
      let numValue = parseFloat(value);

      if (isNaN(numValue) || numValue < 0) {
        numValue = 0;
      }

      if (numValue > oweAmount) {
        this.$message.warning(`收款金额不能超过欠款金额(${oweAmount.toFixed(2)})`);
        numValue = oweAmount;
      }

      this.matchForm.invoiceAmounts[financeId] = numValue;
    },

    // 获取账单的唯一标识
    getInvoiceKey(invoice) {
      return invoice.finance_id || invoice.id;
    },

    // 获取验证消息
    getValidationMessage() {
      if (this.selectedBankIncomes.length === 0) {
        return '请选择一条银行流水';
      }

      const bankIncome = this.selectedBankIncomes[0];
      const unverifiedAmount = parseFloat(bankIncome.amount) - parseFloat(bankIncome.use_amount);
      const totalAmount = this.totalInvoiceAmount;

      if (totalAmount <= 0) {
        return '请至少填写一条账单的收款金额';
      }

      if (totalAmount > unverifiedAmount) {
        return `错误：总收款金额(${totalAmount.toFixed(2)})超过未勾兑金额(${unverifiedAmount.toFixed(2)})`;
      }

      return `验证通过：总收款金额(${totalAmount.toFixed(2)}) ≤ 未勾兑金额(${unverifiedAmount.toFixed(2)})`;
    },

    // 验证是否通过
    isValidationPassed() {
      if (this.selectedBankIncomes.length === 0) {
        return false;
      }

      const bankIncome = this.selectedBankIncomes[0];
      const unverifiedAmount = parseFloat(bankIncome.amount) - parseFloat(bankIncome.use_amount);
      const totalAmount = this.totalInvoiceAmount;

      return totalAmount > 0 && totalAmount <= unverifiedAmount;
    }
  }
};
</script>

<style scoped>
.bank-income-container {
  padding: 10px;
}

.search-bar {
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.upload-demo {
  margin-top: 20px;
}

/* 匹对对话框样式 */
.match-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.match-section {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 15px;
  background-color: #fafafa;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 2px solid #409eff;
}

.section-summary {
  margin-top: 15px;
  padding: 10px;
  background-color: #fff;
  border-radius: 4px;
  text-align: right;
  font-size: 14px;
}

.match-validation {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/BankIncome.vue